export interface PriceAndRightsProps {
  priceLabel?: string | null;
  licenseLabel?: string;
  trialLabel?: string | null;
  compact?: boolean;
}

export function PriceAndRights({
  priceLabel,
  licenseLabel = 'Controlled use',
  trialLabel,
  compact = false,
}: PriceAndRightsProps) {
  const isFree = !priceLabel;
  return (
    <div
      className="ui-price-rights"
      style={{
        display: 'flex',
        flexDirection: compact ? 'row' : 'column',
        gap: compact ? '0.75rem' : '0.35rem',
        alignItems: compact ? 'center' : 'flex-start',
        flexWrap: 'wrap',
      }}
    >
      <span
        style={{
          fontWeight: 700,
          fontSize: compact ? '0.9375rem' : '1.125rem',
          color: 'var(--3ds-text-primary, #111)',
        }}
      >
        {isFree ? 'Free' : priceLabel}
      </span>
      <span style={{ fontSize: '0.875rem', color: 'var(--3ds-text-secondary, #5F5F5F)' }}>
        {licenseLabel}
        {trialLabel ? ` · ${trialLabel}` : ''}
      </span>
    </div>
  );
}
